import * as THREE from 'three';
import { slidingHandleSpec } from './slidingHandleSpec';

export function makeSlidingHandle(options, materials) {
  const spec = slidingHandleSpec(options), group = new THREE.Group();
  group.name = 'sliding-door-handle';
  group.userData.slidingDoorHandle = spec;
  group.position.set(spec.x, spec.y, 0);
  const box = (size, y, z, material = materials.steel) => {
    const mesh = new THREE.Mesh(new THREE.BoxGeometry(...size), material);
    mesh.position.set(0, y, z * spec.face); mesh.castShadow = true; mesh.receiveShadow = true; group.add(mesh);
  };
  if (spec.pocket) {
    // A flush finger pull stays within the pocket's clearance, unlike a proud grip.
    box([.014, .16, .0015], 0, spec.surface + .00075);
    box([.009, .136, .0006], 0, spec.surface + .0018, materials.gasket);
  } else {
    const gripCenter = spec.surface + .035, nearGrip = gripCenter - .008;
    box([.016, .24, .016], 0, gripCenter);
    for (const y of [-.108, .108]) box([.014, .016, nearGrip - spec.surface + .003], y, (nearGrip + spec.surface) / 2);
  }
  return group;
}

export function positionSlidingHandle(handle, panel) {
  handle.position.x = panel.x + handle.userData.slidingDoorHandle.x;
  handle.position.z = panel.z;
}

export function slidingHandleStatus(root) {
  root.updateMatrixWorld(true);
  const handles = [], position = new THREE.Vector3();
  root.traverse(node => {
    const spec = node.userData.slidingDoorHandle; if (!spec) return;
    root.worldToLocal(node.getWorldPosition(position));
    handles.push({ system: spec.system, type: spec.type, panelIndex: spec.panelIndex, edge: spec.edge, face: spec.face,
      heightInches: +(position.y / .0254).toFixed(3), x: +position.x.toFixed(5), z: +position.z.toFixed(5), inset: spec.inset });
  });
  return JSON.stringify(handles);
}